/** Catálogo de procedimentos de demonstração. Espelha as sementes `0005` e `0015`. */

import type { CampoPersonalizado, CustoExtra, TipoDeValor } from './tipos';

export interface ProcedimentoSemente {
    id: string;
    nome: string;
    categoria: string;
    duracaoMin: number;
    precoCentavos: number;
    tipoValor: TipoDeValor;
    reconsultaDias: number;
    cor?: string;
    descricao?: string;
    exigeSala: boolean;
    ativo: boolean;
    profissionaisIds: string[];
    custosExtras: CustoExtra[];
    camposPersonalizados: CampoPersonalizado[];
}

export interface InsumoSemente {
    procedimentoId: string;
    produtoId: string;
    /** Em unidade de consumo. */
    quantidade: number;
}

export const PROCEDIMENTOS: ProcedimentoSemente[] = [
    { id: 'prc-1', nome: 'Retorno', categoria: 'Consulta', duracaoMin: 30, precoCentavos: 0, tipoValor: 'fixo', reconsultaDias: 0, cor: '#D0D5DD', exigeSala: false, ativo: true, profissionaisIds: ['m-paulo'], custosExtras: [], camposPersonalizados: [] },
    { id: 'prc-2', nome: 'Avaliação facial', categoria: 'Consulta', duracaoMin: 60, precoCentavos: 15000, tipoValor: 'fixo', reconsultaDias: 0, cor: '#E094A9', exigeSala: true, ativo: true, profissionaisIds: ['m-ana', 'm-paulo'], custosExtras: [], camposPersonalizados: [] },
    { id: 'prc-3', nome: 'Limpeza de pele', categoria: 'Estética', duracaoMin: 60, precoCentavos: 38000, tipoValor: 'fixo', reconsultaDias: 30, cor: '#22C55E', exigeSala: true, ativo: true, profissionaisIds: ['m-leticia', 'm-ana'], custosExtras: [], camposPersonalizados: [] },
    { id: 'prc-4', nome: 'Peeling', categoria: 'Estética', duracaoMin: 60, precoCentavos: 74000, tipoValor: 'fixo', reconsultaDias: 45, cor: '#F59E0B', exigeSala: true, ativo: true, profissionaisIds: ['m-ana'], custosExtras: [], camposPersonalizados: [] },
    {
        id: 'prc-5', nome: 'Toxina botulínica', categoria: 'Injetável', duracaoMin: 60, precoCentavos: 210000,
        tipoValor: 'fixo', reconsultaDias: 120, cor: '#8B5CF6', exigeSala: true, ativo: true,
        profissionaisIds: ['m-ana', 'm-paulo'],
        /* Descarte e luva entram no preço e não saem do estoque — sem eles a
           margem sai otimista. */
        custosExtras: [
            { id: 'cex-1', nome: 'Descarte de perfurocortante', quantidade: 1, unidade: 'und', valorCentavos: 1200 },
            { id: 'cex-2', nome: 'Par de luvas', quantidade: 2, unidade: 'par', valorCentavos: 350 },
        ],
        camposPersonalizados: [],
    },
    {
        id: 'prc-6', nome: 'Harmonização', categoria: 'Injetável', duracaoMin: 90, precoCentavos: 240000,
        tipoValor: 'fixo', reconsultaDias: 180, cor: '#3B82F6', exigeSala: true, ativo: true,
        profissionaisIds: ['m-paulo'],
        custosExtras: [{ id: 'cex-3', nome: 'Descarte de perfurocortante', quantidade: 1, unidade: 'und', valorCentavos: 1200 }],
        camposPersonalizados: [],
    },
];

/* Quantidades em unidade de CONSUMO: 50 UI de toxina (meio frasco de 100 UI),
   2.000 µl de preenchedor (2 ml), 4 agulhas, 3 g de anestésico. */
export const INSUMOS_DOS_PROCEDIMENTOS: InsumoSemente[] = [
    { procedimentoId: 'prc-5', produtoId: 'prd-1', quantidade: 50 },
    { procedimentoId: 'prc-5', produtoId: 'prd-5', quantidade: 4 },
    { procedimentoId: 'prc-5', produtoId: 'prd-6', quantidade: 3 },
    { procedimentoId: 'prc-6', produtoId: 'prd-2', quantidade: 2000 },
    { procedimentoId: 'prc-6', produtoId: 'prd-5', quantidade: 6 },
    { procedimentoId: 'prc-6', produtoId: 'prd-6', quantidade: 4 },
    { procedimentoId: 'prc-3', produtoId: 'prd-4', quantidade: 1 },
    { procedimentoId: 'prc-4', produtoId: 'prd-3', quantidade: 10 },
    { procedimentoId: 'prc-4', produtoId: 'prd-4', quantidade: 1 },
];
